import { createSelector } from 'reselect'
import { PeopleContactsState } from 'src/app/PeopleContacts/redux/peopleContacts.reducer'
import { userEmailOption } from 'src/components/UserDropdown/UserDropdown'
import { RootState } from 'src/redux/createRootReducer'
import { selectUserListModelFromState } from 'src/redux/selectors/auth.selectors'
import { selectContactsListModelsFromState } from 'src/redux/selectors/data/contacts.selectors'

export const selectContactsFullPaginatedData = (
  state: RootState,
): PeopleContactsState => state.app.invitePeople.contactsFullPaginatedData
export const selectPostingUserInvitesFromState = (state: RootState): boolean =>
  state.app.invitePeople.contactsFullPaginatedData.postingUserInvites
export const selectTopLevelErrorFromState = (
  state: RootState,
): string | undefined =>
  state.app.invitePeople.contactsFullPaginatedData.postInvitesTopLevelError

export const selectUniqueContactIds = createSelector(
  [selectContactsFullPaginatedData],
  (data) => data.ids.filter((id, i) => data.ids.indexOf(id) === i),
)
export const selectUniqueContactEmailOptions = createSelector(
  [selectUniqueContactIds, selectContactsListModelsFromState],
  (ids, contacts) => ids.map((id) => userEmailOption(contacts[id].userTo)),
)

export const selectFilteredContactEmailOptions = createSelector(
  [selectUniqueContactEmailOptions, selectUserListModelFromState],
  (options, user) =>
    // filtering out contacts that already belong to the user's org
    options.filter(
      (option) => option.details?.user.organizationId !== user?.organizationId,
    ),
)
